module.exports = __webpack_public_path__ + "static/media/backup-clinical-allergy-bg.c62ced9d.png";